import { render, staticRenderFns } from "./ContractPreview.vue?vue&type=template&id=4ddc0654&scoped=true&"
import script from "./ContractPreview.vue?vue&type=script&lang=js&"
export * from "./ContractPreview.vue?vue&type=script&lang=js&"
import style0 from "./ContractPreview.vue?vue&type=style&index=0&id=4ddc0654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddc0654",
  null
  
)

export default component.exports